<template>
  <div class="bg">
    <div class="content">
      <el-form label-width="auto" label-position="left">
        <el-card>
          <el-row>
            <el-form-item label="所属项目：">
              <span>
                {{ project }}
              </span>
            </el-form-item>
            <el-form-item label="所属企业：">
              <span>
                {{ detailInfo.title }}
              </span>
            </el-form-item>
            <el-form-item label="单位类型：">
              <span>
                {{ detailInfo.type }}
              </span>
            </el-form-item>
            <el-form-item label="进场状态：">
              <span>
                {{ detailInfo.status }}
              </span>
            </el-form-item>
            <el-form-item label="进场日期：">
              <span>
                {{ detailInfo.entryTime }}
              </span>
            </el-form-item>
            <el-form-item label="退场日期：">
              <span>{{ detailInfo.exitTime }}</span>
            </el-form-item>
            <el-form-item label="备注信息：">
              <span v-if="detailInfo.remark == ''">无</span>
              <span v-else>{{ detailInfo.remark }}</span>
            </el-form-item>
          </el-row>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postDictCode } from "@/api/dict";
import { postProjectId } from "@/api/app/project";
import { postListUnit, postUnitDetail } from "@/api/app/unit";
export default {
  data() {
    return {
      showFartherPopup: false,
      showCompanyTypePopup: false,
      detailInfo: {},
      project: "",
    };
  },
  created() {
    this.detail();
  },

  methods: {
    detail() {
      // 通过参建单位id获取详细信息
      postUnitDetail(this.$store.state.app.itemId).then((detail) => {
        this.detailInfo = detail.data;
        postProjectId(this.$store.state.app.projectId).then((projectName) => {
          this.project = projectName.data.name;
        });
        // 查询项目下的所有参建单位,进行匹配
        postListUnit(this.$store.state.app.projectId).then((res) => {
          res.data.find((items) => {
            if (items.id == this.$store.state.app.itemId) {
              this.detailInfo["title"] = items.title;
              this.$store.state.app.dict.find((item) => {
                if (this.detailInfo.status == item.value) {
                  postDictCode("units_type").then((res) => {
                    res.data.find((item) => {
                      if (item.value == this.detailInfo.type) {
                        this.detailInfo.type = item.label;
                      }
                    });
                  });
                  this.detailInfo["status"] = item.label;
                  this.detailInfo["remark"] = this.detailInfo.remark;
                }
              });
            } else {
              this.$store.state.app.dict.find((item) => {
                if (this.detailInfo.status == item.value) {
                  postDictCode("units_type").then((res) => {
                    res.data.find((item) => {
                      if (item.value == this.detailInfo.type) {
                        this.detailInfo.type = item.label;
                      }
                    });
                  });
                  this.detailInfo["status"] = item.label;
                  this.detailInfo["remark"] = this.detailInfo.remark;
                }
              });
            }
          });
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.content {
  .el-form-item {
    margin: 0px;
    font-size: 14px;
  }
  p {
    i {
      font-size: 12px;
    }
  }
  /deep/ .el-input__inner {
    border: unset;
    padding: 0;
  }
}
</style>
